import { default as _91_46_46_46cms_933nbWLnind9Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_939WGzHOBSc8Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexg8VfqwdSJPMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93aLZbsugwkVMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/akcii/[...slug].vue?macro=true";
import { default as indexm1R4vkC10JMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93f9yb9xSU2lMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/articles/[...slug].vue?macro=true";
import { default as indexP8B76aMWeYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/articles/index.vue?macro=true";
import { default as index6lBdsgISYvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/authorization/index.vue?macro=true";
import { default as index29gasIE6xKMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93eA3C2e5EBjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93HW5frwEB85Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalog/[...slug].vue?macro=true";
import { default as index46H76nZp6pMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93OGzXVS7lGPMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalogsearch/[...slug].vue?macro=true";
import { default as result2H1IdLmif6Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalogsearch/result.vue?macro=true";
import { default as indexWfXqEpir0wMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93QessRUhvNEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93FkMZRNVFVjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/fabriki/[...slug].vue?macro=true";
import { default as indexsES6ATup0YMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93fYQUw7Lc9CMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93rlmFfBGqinMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/product/[...slug].vue?macro=true";
import { default as indexWGhiD8WWAUMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/profile/index.vue?macro=true";
import { default as indexByBTorQJQcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/profile/orders/index.vue?macro=true";
import { default as indexLc5x7tKgLPMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93uEdVaXAMlmMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/sets/[...slug].vue?macro=true";
import { default as indexJz9YpZ2I7wMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_933nbWLnind9Meta?.name ?? "cms",
    path: _91_46_46_46cms_933nbWLnind9Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_933nbWLnind9Meta || {},
    alias: _91_46_46_46cms_933nbWLnind9Meta?.alias || [],
    redirect: _91_46_46_46cms_933nbWLnind9Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_939WGzHOBSc8Meta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_939WGzHOBSc8Meta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_939WGzHOBSc8Meta || {},
    alias: _91_46_46_46slug_939WGzHOBSc8Meta?.alias || [],
    redirect: _91_46_46_46slug_939WGzHOBSc8Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexg8VfqwdSJPMeta?.name ?? "3d-projects",
    path: indexg8VfqwdSJPMeta?.path ?? "/3d-projects",
    meta: indexg8VfqwdSJPMeta || {},
    alias: indexg8VfqwdSJPMeta?.alias || [],
    redirect: indexg8VfqwdSJPMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93aLZbsugwkVMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93aLZbsugwkVMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93aLZbsugwkVMeta || {},
    alias: _91_46_46_46slug_93aLZbsugwkVMeta?.alias || [],
    redirect: _91_46_46_46slug_93aLZbsugwkVMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexm1R4vkC10JMeta?.name ?? "akcii",
    path: indexm1R4vkC10JMeta?.path ?? "/akcii",
    meta: indexm1R4vkC10JMeta || {},
    alias: indexm1R4vkC10JMeta?.alias || [],
    redirect: indexm1R4vkC10JMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93f9yb9xSU2lMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93f9yb9xSU2lMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93f9yb9xSU2lMeta || {},
    alias: _91_46_46_46slug_93f9yb9xSU2lMeta?.alias || [],
    redirect: _91_46_46_46slug_93f9yb9xSU2lMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexP8B76aMWeYMeta?.name ?? "articles",
    path: indexP8B76aMWeYMeta?.path ?? "/articles",
    meta: indexP8B76aMWeYMeta || {},
    alias: indexP8B76aMWeYMeta?.alias || [],
    redirect: indexP8B76aMWeYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: index6lBdsgISYvMeta?.name ?? "authorization",
    path: index6lBdsgISYvMeta?.path ?? "/authorization",
    meta: index6lBdsgISYvMeta || {},
    alias: index6lBdsgISYvMeta?.alias || [],
    redirect: index6lBdsgISYvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: index29gasIE6xKMeta?.name ?? "cart",
    path: index29gasIE6xKMeta?.path ?? "/cart",
    meta: index29gasIE6xKMeta || {},
    alias: index29gasIE6xKMeta?.alias || [],
    redirect: index29gasIE6xKMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93eA3C2e5EBjMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93eA3C2e5EBjMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93eA3C2e5EBjMeta || {},
    alias: _91_46_46_46id_93eA3C2e5EBjMeta?.alias || [],
    redirect: _91_46_46_46id_93eA3C2e5EBjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93HW5frwEB85Meta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93HW5frwEB85Meta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93HW5frwEB85Meta || {},
    alias: _91_46_46_46slug_93HW5frwEB85Meta?.alias || [],
    redirect: _91_46_46_46slug_93HW5frwEB85Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index46H76nZp6pMeta?.name ?? "catalog",
    path: index46H76nZp6pMeta?.path ?? "/catalog",
    meta: index46H76nZp6pMeta || {},
    alias: index46H76nZp6pMeta?.alias || [],
    redirect: index46H76nZp6pMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93OGzXVS7lGPMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93OGzXVS7lGPMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93OGzXVS7lGPMeta || {},
    alias: _91_46_46_46slug_93OGzXVS7lGPMeta?.alias || [],
    redirect: _91_46_46_46slug_93OGzXVS7lGPMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: result2H1IdLmif6Meta?.name ?? "catalogsearch-result",
    path: result2H1IdLmif6Meta?.path ?? "/catalogsearch/result",
    meta: result2H1IdLmif6Meta || {},
    alias: result2H1IdLmif6Meta?.alias || [],
    redirect: result2H1IdLmif6Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexWfXqEpir0wMeta?.name ?? "clear-page-slider",
    path: indexWfXqEpir0wMeta?.path ?? "/clear-page-slider",
    meta: indexWfXqEpir0wMeta || {},
    alias: indexWfXqEpir0wMeta?.alias || [],
    redirect: indexWfXqEpir0wMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93QessRUhvNEMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93QessRUhvNEMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93QessRUhvNEMeta || {},
    alias: _91_46_46_46slug_93QessRUhvNEMeta?.alias || [],
    redirect: _91_46_46_46slug_93QessRUhvNEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93FkMZRNVFVjMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93FkMZRNVFVjMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93FkMZRNVFVjMeta || {},
    alias: _91_46_46_46slug_93FkMZRNVFVjMeta?.alias || [],
    redirect: _91_46_46_46slug_93FkMZRNVFVjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexsES6ATup0YMeta?.name ?? "fabriki",
    path: indexsES6ATup0YMeta?.path ?? "/fabriki",
    meta: indexsES6ATup0YMeta || {},
    alias: indexsES6ATup0YMeta?.alias || [],
    redirect: indexsES6ATup0YMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93fYQUw7Lc9CMeta?.name ?? "order-status-hash",
    path: _91hash_93fYQUw7Lc9CMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93fYQUw7Lc9CMeta || {},
    alias: _91hash_93fYQUw7Lc9CMeta?.alias || [],
    redirect: _91hash_93fYQUw7Lc9CMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93rlmFfBGqinMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93rlmFfBGqinMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93rlmFfBGqinMeta || {},
    alias: _91_46_46_46slug_93rlmFfBGqinMeta?.alias || [],
    redirect: _91_46_46_46slug_93rlmFfBGqinMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexWGhiD8WWAUMeta?.name ?? "profile",
    path: indexWGhiD8WWAUMeta?.path ?? "/profile",
    meta: indexWGhiD8WWAUMeta || {},
    alias: indexWGhiD8WWAUMeta?.alias || [],
    redirect: indexWGhiD8WWAUMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexByBTorQJQcMeta?.name ?? "profile-orders",
    path: indexByBTorQJQcMeta?.path ?? "/profile/orders",
    meta: indexByBTorQJQcMeta || {},
    alias: indexByBTorQJQcMeta?.alias || [],
    redirect: indexByBTorQJQcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexLc5x7tKgLPMeta?.name ?? "recently",
    path: indexLc5x7tKgLPMeta?.path ?? "/recently",
    meta: indexLc5x7tKgLPMeta || {},
    alias: indexLc5x7tKgLPMeta?.alias || [],
    redirect: indexLc5x7tKgLPMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93uEdVaXAMlmMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93uEdVaXAMlmMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93uEdVaXAMlmMeta || {},
    alias: _91_46_46_46slug_93uEdVaXAMlmMeta?.alias || [],
    redirect: _91_46_46_46slug_93uEdVaXAMlmMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexJz9YpZ2I7wMeta?.name ?? "wishlist",
    path: indexJz9YpZ2I7wMeta?.path ?? "/wishlist",
    meta: indexJz9YpZ2I7wMeta || {},
    alias: indexJz9YpZ2I7wMeta?.alias || [],
    redirect: indexJz9YpZ2I7wMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260922071134/pages/wishlist/index.vue").then(m => m.default || m)
  }
]